<img
    class="image-button__image"
    [src]="src"
    [alt]="alt"
    [style]="'width:' + style.width"
>
